import { of as observableOf, Observable } from 'rxjs';

import { catchError, map, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { GoogleGeocodeService } from '../../shared/services/index';
import { CAAction } from '../actions';
import * as actions from './location.actions';

@Injectable()
export class LocationEffects {
  
  requestLocation = createEffect(() => this.actions$.pipe(
    ofType<CAAction>(actions.REQUEST_LOCATION),
    switchMap(action => {
      return this.locationService.requestLocation(action.payload).pipe(
        map(response => new actions.ResponseSuccessLocation(response)),
        catchError(err => observableOf(new actions.ResponseFailLocation(err)))
      );
    })
  ));

  constructor(
    private actions$: Actions<CAAction>,
    private locationService: GoogleGeocodeService
  ) {}
}
